import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Download = createReactComponent("Download", ["svg", defaultAttributes, [["path", {
  d: "M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4",
  key: "x5hunq"
}], ["polyline", {
  points: "7 10 12 15 17 10",
  key: "uq33c5"
}], ["line", {
  x1: "12",
  y1: "15",
  x2: "12",
  y2: "3",
  key: "32l95z"
}]]]);
export default Download;